let amplitude = null

const isBrowser = typeof window !== 'undefined'

let initialized = false

const init = async () => {
  if (!isBrowser || initialized) return
  initialized = true
  amplitude = await import('@amplitude/unified')
  amplitude.initAll('f5e627c393f99568a65f31bff0cd2f87', {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  })
}

const track = (eventName, properties) => {
  if (!isBrowser || !amplitude) return
  amplitude.track(eventName, properties)
}

const identify = properties => {
  if (!isBrowser || !amplitude) return
  const identifyObj = new amplitude.Identify()
  Object.entries(properties).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      identifyObj.set(key, value)
    }
  })
  amplitude.identify(identifyObj)
}

module.exports = { init, track, identify }
